export default [
  {
    path: "/h5/property",
    name: "h5-property",
    redirect: '/h5/property/index',
    component: () => import('@/pages/v2/h5/property/index'),
    children: [
      {
        path: 'index',
				name: 'Overview', // 资产总览
				component: () => import("@/pages/v2/h5/property/overview"),
      },
      {
        path: 'property-account',
				name: 'PropertyAccount', // 资金
				component: () => import("@/pages/v2/h5/property/propertyAccount"),
      },
      {
        path: 'property-account/history',
				name: 'PropertyAccount', // 资金历史记录
				component: () => import("@/pages/v2/h5/property/propertyAccount/history"),
      },
      {
        path: 'property-account/recharge',
				name: 'PropertyAccount', // 充值
				component: () => import("@/pages/v2/h5/property/propertyAccount/recharge"),
      },
      {
        path: 'property-account/withdrawal',
				name: 'PropertyAccount', // 提现
				component: () => import("@/pages/v2/h5/property/propertyAccount/withdrawal"),
      },
      {
        path: 'buying-account',
				name: 'BuyingAccount', // 买币
				component: () => import("@/pages/v2/h5/property/buyingAccount"),
      },
      {
        path: 'buying-account/history',
				name: 'BuyingAccount', // 历史记录
				component: () => import("@/pages/v2/h5/property/buyingAccount/history"),
      },
      {
        path: 'spot-account',
				name: 'SpotAccount', // 现货
				component: () => import("@/pages/v2/h5/property/spotAccount"),
      },
      {
        path: 'spot-account/history',
				name: 'SpotAccount', // 历史记录
				component: () => import("@/pages/v2/h5/property/spotAccount/history"),
      },
      {
        path: 'contract-account',
				name: 'ContractAccount', // 合约
				component: () => import("@/pages/v2/h5/property/contractAccount"),
      },
      {
        path: 'contract-account/history',
				name: 'ContractAccount', // 历史记录
				component: () => import("@/pages/v2/h5/property/contractAccount/history"),
      },
      {
        path: 'documentary-account',
				name: 'DocumentaryAccount', // 跟单
				component: () => import("@/pages/v2/h5/property/documentaryAccount"),
      },
      {
        path: 'documentary-account/history',
				name: 'DocumentaryAccount', // 历史记录
				component: () => import("@/pages/v2/h5/property/documentaryAccount/history"),
      },
      {
        path: 'gift-account',
				name: 'GiftAccount', // 赠金
				component: () => import("@/pages/v2/h5/property/giftAccount"),
      },
      {
        path: 'gift-account/history',
				name: 'GiftAccount', // 历史记录
				component: () => import("@/pages/v2/h5/property/giftAccount/history"),
      },
      {
        path: 'game-account',
				name: 'GameAccount', // 趣投
				component: () => import("@/pages/v2/h5/property/gameAccount"),
      },
      {
        path: 'game-account/history',
				name: 'GameAccount', // 历史记录
				component: () => import("@/pages/v2/h5/property/gameAccount/history"),
      },
      {
        path: 'biking-account',
				name: 'BikingAccount', // 币王卡
				component: () => import("@/pages/v2/h5/property/bikingAccount"),
      },
      {
        path: 'earn-account',
				name: 'EarnAccount', // 理财
				component: () => import("@/pages/v2/h5/property/earnAccount"),
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/v2/h5/property/index.js